import { generateMutations } from '../builder'

export default {
  ...generateMutations('getThematics', 'thematics'),
  ...generateMutations('saveThematic', 'thematic'),
  ...generateMutations('getThematic', 'thematic'),
  ...generateMutations('deleteThematic'),
}
